import type { SeoResolver } from '../types';

/**
 * SEO for a selected land parcel. Moved verbatim from SEO.tsx. The
 * ENABLE_LAND_PARCEL feature gate is applied upstream (SEO.tsx only passes a
 * parcel into `selections` when the feature is on).
 */
export const landParcelSeoResolver: SeoResolver = (ctx) => {
  const parcel = ctx.selections.landParcel;
  if (!parcel) return null;

  const { siteName, layerName } = ctx;
  const p = parcel.properties;

  return {
    title: `${p.survey_number}/${p.sub_division} in ${p.village_name || p.revenue_town_name} | ${layerName} | ${siteName}`,
    description: `View cadastral details and boundary for Survey Parcel ${p.survey_number}/${p.sub_division} in ${p.village_name || p.revenue_town_name}, ${p.district_name}. Accurate GIS mapping on ${siteName}.`,
    breadcrumbLabel: `${p.survey_number}/${p.sub_division}`
  };
};
